import { send } from 'server';

import { TGetRecentlyPlayed } from './types';

export const getRecentlyPlayed = (): Promise<TGetRecentlyPlayed> => send({
    ID: 35547,
    tagName: 'uam/hidden/playerRecentGames',
    description: 'get recently played games',
    responses: [35548, 35549]
});
